import Plugin from '@antv/g6-plugin';
export default Plugin;
// export default {};